<template>
  <section class="animated fadeIn">
    <h1 v-if="msg">{{ msg }}</h1>
    <div class="btn-primary" @click="$emit('phone')">验证手机号</div>
  </section>
</template>

<script>
export default {
  name: "Auth",
  props: ["msg"],
}
</script>

<style lang="scss" scoped>
@import "./style.scss";

h1 {
  font-size: 1rem;
  margin: 0 0 15px 0;
  @include avenir-demi();
}

.animated {
  animation-duration: 0.5s !important;
}
</style>
